import Vue from 'vue'
import Router from 'vue-router'
import { ROUTE } from './paths'
import loginVerifyCode from '@/components/loginVerifyCode'
import shareRegister from '@/components/shareRegister'
import home from '@/components/home'
import error from '@/components/error'

import AttendClassNow from '@/components/children/AttendClassNow'
import ClassEnrolled from '@/components/children/ClassEnrolled'
import ViewCompletedLessons from '@/components/children/ViewCompletedLessons'
import Address from '@/components/children/Address'
import Videoclass from '@/components/children/Videoclass'
import ClassDetail from '@/components/children/ClassDetail'
import Homework from '@/components/children/Homework'
import VideoPlay from '@/components/views/VideoPlay'
import information from '@/components/children/information'
import addChildren from '@/components/children/addChildren'
import Transaction from '@/components/children/Transaction'
import MonthlyPassUser from '@/components/children/MonthlyPassUser'
import ChangePlan from '@/components/children/ChangePlan'
import MonthyuStatement from '@/components/children/MonthyuStatement'
import Salecard from '@/components/salecard'

import newUser from '@/components/newUser'
import sinadd from '@/components/sinadd'
import service from '@/components/views/service'
import police from '@/components/views/police'
import contract from '@/components/views/contract'
import ChildrenHome from '@/components/children/ChildrenHome'

Vue.use(Router)

function layoutRoute (path, name, component) {
  return {
    path,
    component: home,
    children: [
      {
        path: '',
        name,
        component
      }
    ]
  }
}

export default new Router({
  routes: [
    {
      path: ROUTE.LOGIN,
      name: 'loginVerifyCode',
      component: loginVerifyCode
    },
    {
      path: ROUTE.SALE_CARD,
      name: 'salecard',
      component: Salecard
    },
    {
      path: ROUTE.NEW_USER,
      name: 'newUser',
      component: newUser
    },
    {
      path: ROUTE.ONBOARDING,
      name: 'sinadd',
      component: sinadd
    },
    {
      path: ROUTE.REGISTER,
      name: 'shareRegister',
      component: shareRegister
    },
    {
      path: ROUTE.SERVICE,
      name: 'service',
      component: service
    },
    {
      path: ROUTE.PRIVACY,
      name: 'police',
      component: police
    },
    {
      path: ROUTE.CONTRACT,
      name: 'contract',
      component: contract
    },
    {
      path: ROUTE.VIDEO_PLAY,
      name: 'VideoPlay',
      component: VideoPlay,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/index',
      redirect: ROUTE.HOME
    },
    layoutRoute(ROUTE.HOME, 'home', ChildrenHome),
    layoutRoute(ROUTE.ATTEND, 'attend', AttendClassNow),
    layoutRoute(ROUTE.ENROLLED, 'enrolled', ClassEnrolled),
    layoutRoute(ROUTE.COMPLETED, 'completed', ViewCompletedLessons),
    layoutRoute(ROUTE.ADDRESS, 'address', Address),
    layoutRoute(ROUTE.VIDEO, 'video', Videoclass),
    layoutRoute(ROUTE.HOMEWORK, 'homework', Homework),
    layoutRoute(ROUTE.CLASS_DETAIL, 'classDetail', ClassDetail),
    layoutRoute(ROUTE.PROFILE, 'profile', information),
    layoutRoute(ROUTE.ADD_CHILDREN, 'addChildren', addChildren),
    layoutRoute(ROUTE.TRANSACTION, 'transaction', Transaction),
    layoutRoute(ROUTE.MEMBERSHIP, 'membership', MonthlyPassUser),
    layoutRoute(ROUTE.CHANGE_PLAN, 'changePlan', ChangePlan),
    layoutRoute(ROUTE.STATEMENT, 'statement', MonthyuStatement),
    {
      path: '*',
      component: error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js